import type { CabinClass, CombinedUpgradeApiRow } from '~/services/CharterService';

export type { CabinClass, CombinedUpgradeApiRow };

export const CABIN_CLASS_LABELS: Record<CabinClass, string> = {
  ECONOMY: 'Economy',
  PREMIUM_ECONOMY: 'Premium Economy',
  LUX_ROW: 'SkyLounge',
  LUX_ROW_PAX_ONE: 'SkyLounge for One',
  BUSINESS: 'Business',
};

export const VALID_UPGRADES_FROM: Record<CabinClass, CabinClass[]> = {
  ECONOMY: ['PREMIUM_ECONOMY', 'LUX_ROW', 'LUX_ROW_PAX_ONE', 'BUSINESS'],
  PREMIUM_ECONOMY: ['LUX_ROW', 'LUX_ROW_PAX_ONE', 'BUSINESS'],
  LUX_ROW: ['BUSINESS'],
  LUX_ROW_PAX_ONE: ['BUSINESS'],
  BUSINESS: [],
};

// Flat list of all valid upgrade pairs (9 entries)
export const VALID_UPGRADE_COMBINATIONS: Array<{ from: CabinClass; to: CabinClass }> = (
  Object.entries(VALID_UPGRADES_FROM) as [CabinClass, CabinClass[]][]
).flatMap(([from, tos]) => tos.map((to) => ({ from, to })));

/** Key used in FlightUpgradeRow for a given combo: `{FROM}_{TO}` */
export function comboKey(from: CabinClass, to: CabinClass): string {
  return `${from}_${to}`;
}

/**
 * One row per flight_instance in the DataGrid.
 * Eligibility (day windows) are per-flight; pricing fields are global (same across all rows for a combo).
 */
export type FlightUpgradeRow = {
  id: string; // flightInstanceId
  depDate: string;
  direction: string; // "MEL → MLE"
  eligibilityId: string | null;
  daysBeforeDepNonTierBronze: number | null;
  daysBeforeDepSilver: number | null;
  daysBeforeDepGoldPlatinum: number | null;
  // 9 combos × 4 fields: `{comboKey}_pricingId`, `{comboKey}_priceAdt`, `{comboKey}_chdPct`, `{comboKey}_infPct`, `{comboKey}_currency`
  [key: string]: unknown;
};
